<template>
  <div class="interactives-text-input">
    <label v-if="inputData.label" :for="inputData.name">{{ inputData.label }}</label>
    <input
      type="text"
      :name="inputData.name"
      :placeholder="inputData.placeholder"
      v-model="value"
    >
  </div>
</template>

<script>

export default {
  name: 'interactives-text-input',
  props: ['inputData'],
  data () {
    return {
      value: null
    }
  },
  watch: {
    value: function (newValue) { this.inputData.value = newValue }
  }
}
</script>

<style>
.interactives-text-input {
  /* styles go here */
}
</style>



// WEBPACK FOOTER //
// ../interactives-input/src/components/TextInput.vue